import { z } from 'zod'

export const PointsSchema = z.object({
  id: z.string(),
  name: z.string(),
  platform: z.string(),
  type: z.string(),
  action_type: z.string(),
  address: z.string(),
  external_link: z.string(),
  img: z.string(),
  multiplier: z.number(),
})

export const PointsArraySchema = z.array(PointsSchema)

export type PointsObject = z.infer<typeof PointsSchema>
export type PointsArray = z.infer<typeof PointsArraySchema>

export const PayoutTermSchema = z.object({
  payee_type: z.enum(['both', 'affiliate', 'end-user']),
  referral_amount: z.string(),
})

export const TriggerSchema = z.object({
  id: z.string(),
  name: z.string(),
  context: z.object({
    pairAddress: z.string().optional(),
    volumeCurrencyAddress: z.string().optional(),
    depositTokenAddress: z.string().optional(),
    token_address: z.string().optional(),
    hyTokenAddress: z.string().optional(),
  }),
  triggerType: z.string(),
  volume_currency_expression: z.string().optional(),
})

export const ConversionWithPayoutTermsSchema = z.object({
  id: z.string(),
  name: z.string(),
  payout_terms: z.array(PayoutTermSchema),
  triggers: z.array(TriggerSchema),
})

export type ConversionWithPayoutTerms = z.infer<typeof ConversionWithPayoutTermsSchema>

export type ExternalPlatform = 'balancer' | 'hybra' | 'hyperswap' | 'kittenswap' | 'valantis' | 'pendle'
export type Platform = ExternalPlatform | 'hypurrfi'

export type EntryType = {
  type: 'pooled' | 'isolated' | 'vault' | 'euler' | 'unknown'
  action_type: 'deposit' | 'borrow' | 'unknown'
}
